/* eslint-disable no-unused-vars */

import './App.css';
import {Sunrise} from "./components";

function App() {
  return (
    <div className="App">
      <Sunrise/>
    </div>
  );
}

export default App;
